/* eslint-disable no-nested-ternary */
/* eslint-disable array-callback-return */
/* eslint-disable max-len */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import tickIconRed from '../../../assets/Icons/tick-icon-red.svg';
import { RootState } from '../../../redux/rootState';
import DataSheetTopTable from './dataSheetTopTable';
import { CombineReportEnum, PDFReportEnum, ReportPart1 } from '../helper';
import { DefectDetails } from '../types';

function DataSheetTable() {
  const {
    reportPdfResponse1, reportPdfResponse2c, themePdfColor, tableContent,
  } = useSelector((state: RootState) => state.reportPdfSliceReducer);
  const { BorderColor, MainColor } = themePdfColor;
  const dataSheetResult = useMemo(() => {
    const res = [];
    const finalDataSheets: DefectDetails[] = [];
    reportPdfResponse1?.VesselJobSubArrays?.map((item) => {
      item?.Vessels?.map((vessel) => {
        const DefSheet = {
          ActionRequired: false,
          Area: '',
          Date: '',
          Defect: '',
          DefectCode: '',
          DefectColor: '',
          DefectDescription: '',
          DefectType: 'NMD',
          Description: 'NO MEASURABLE DEFECTS',
          JobOrder: item?.JobOrder,
          List: '',
          Row: 0,
          SN: 0,
          Section: '',
          Time: '',
          Tube: 0,
          VesselId: String(vessel?.VesselId),
          VesselName: vessel?.VesselName,
        };
        const val = reportPdfResponse2c?.Data_Sheets?.VesselwiseDatasheets?.find((summary) => (summary?.DataSheets?.[0]?.JobOrder === item?.JobOrder && String(summary?.DataSheets?.[0]?.VesselId) === String(vessel?.VesselId)));
        if (val) {
          const def = val.DataSheets?.find((i) => i?.DefectType === 'Defect');
          if (def) {
            finalDataSheets.push(...(val.DataSheets));
          } else {
            const s1Time = val.DataSheets?.find((i) => i?.List === 'Start1');
            const sTime = val.DataSheets?.find((i) => i?.List === 'Start');
            if (sTime && s1Time) {
              finalDataSheets.push(s1Time);
              finalDataSheets.push(sTime);
            }
            finalDataSheets.push(DefSheet);
            const remainingSheets = val?.DataSheets?.filter((i) => (i?.List !== 'Start' && i?.List !== 'Start1'));
            finalDataSheets.push(...remainingSheets);
          }
        } else {
          finalDataSheets.push(DefSheet);
        }
      });
    });
    const len = finalDataSheets?.length;
    for (let i = 0; i < len;) {
      res.push(finalDataSheets?.slice(i, i + 18));
      i += 18;
    }

    return res;
  }, [reportPdfResponse2c, reportPdfResponse1]);

  const lastIndex = dataSheetResult.length - 1;

  return (
    <>
      {dataSheetResult.map((dataResult, index) => (
        <>
          <div className="pageHeader">
            <div className="topHeader">
              <div className={`${index > 0 ? 'pt30 pb10' : ''}`}>
                {ReportPart1(tableContent, CombineReportEnum.COMBINE_DATA_SHEETS, PDFReportEnum.PDF_DATA_SHEETS, 'Data Sheets')}
                {index > 0 && (
                  <>
                    <br />
                    Data Sheets - Page
                    {' '}
                    {index + 1}
                  </>
                )}
              </div>
              <div className={`${index > 0 ? 'pt30 pb10' : ''}`}>{`S/N ${reportPdfResponse2c?.JobOrderData?.SerialNumber}`}</div>
            </div>
            {index === 0 && <div className="underlineHeadingText textCenter">Data Sheet</div>}
          </div>
          {index === 0 && <DataSheetTopTable />}
          <table className="bordered-table w100 mt40">
            <div
              className="tableAfterThickBorderStyle"
              style={{
                backgroundColor: BorderColor,
              }}
            />
            <div
              className="tableBeforeThickBorderStyle"
              style={{
                backgroundColor: BorderColor,
              }}
            />
            <tr>
              <td className="tableGreenHeading textCenter boldText w8" style={{ backgroundColor: MainColor }}>
                Section
              </td>
              <td className="tableGreenHeading textCenter boldText w6" style={{ backgroundColor: MainColor }}>
                Row
              </td>
              <td className="tableGreenHeading textCenter boldText w6" style={{ backgroundColor: MainColor }}>
                Tube
              </td>
              <td className="tableGreenHeading textCenter boldText w17" style={{ backgroundColor: MainColor }}>
                Vessel
              </td>
              <td className="tableGreenHeading textCenter boldText w50" style={{ backgroundColor: MainColor }}>
                Description
              </td>
              <td className="tableGreenHeading textCenter boldText w13" style={{ backgroundColor: MainColor }}>
                Area
              </td>
              <td className="tableGreenHeading textCenter boldText w8" style={{ backgroundColor: MainColor }}>
                Action Req.
              </td>
            </tr>
            {dataResult.map((details) => (
              details.Row > 0 || details.Tube > 0 ? (
                <tr key={`${details.Section}-${details.Row}-${details.Tube}`}>
                  <td className="textCenter">{details.Section}</td>
                  <td className="textCenter">{details.Row}</td>
                  <td className="textCenter">{details.Tube}</td>
                  <td className="textCenter">{details.VesselName}</td>
                  <td className="textCenter" style={details.ActionRequired ? { color: 'red' } : {}}>{details.DefectDescription}</td>
                  <td className="textCenter">{details.Area}</td>
                  <td className="textCenter">{details.ActionRequired && <img src={tickIconRed} alt="icon" width="18px" />}</td>
                </tr>
              ) : details?.DefectType === 'NMD' ? (
                <tr>
                  <td className="textCenter" colSpan={3}>{}</td>
                  <td className="textCenter">{details.VesselName}</td>
                  <td className="textCenter">{details.Description}</td>
                  <td className="textCenter" colSpan={2}>{}</td>
                </tr>
              ) : (details?.DefectType === 'Start' || details?.DefectType === 'Finish') ? (
                <tr>
                  <td className="textCenter boldText" colSpan={7} style={{ backgroundColor: '#f8f9fa' }}>
                    {`${details.VesselName} ${details.DefectType}`}
                  </td>
                </tr>
              ) : (
                <tr>
                  <td className="textCenter boldText" colSpan={7} style={{ backgroundColor: '#f8f9fa' }}>
                    {details.Description}
                  </td>
                </tr>
              )
            ))}
          </table>
          {index !== lastIndex && (
          <div className="page-break" />
          )}
        </>
      ))}
    </>
  );
}

export default DataSheetTable;
